import React from 'react';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import Icon from 'bz-icons/src/controls/icon';

import Menu from 'tm3-core/controls/menus';

import MenuStore from 'tm3-core/controls/menus/stores';
import ReportsList from '../../../reports-list';

import { Button } from '@material-ui/core';

@inject('clinicalStore')
@observer
class ReportsMenu extends React.Component {
  render() {
    return (
      <div>
        <Button variant={'outlined'} onClick={this.onOpen}>
          <Icon width={16} height={16} value="0151_plus_add_new" />
          <span>Add Report</span>
        </Button>
        <Menu
          dense={true}
          anchorEl={MenuStore.anchorEl}
          open={this.open}
          onClose={MenuStore.close}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <ReportsList />
        </Menu>
      </div>
    );
  }

  @computed
  get open() {
    return MenuStore.isOpen('clinical-footer-add-report');
  }

  @action.bound
  onOpen(e: any) {
    MenuStore.open('clinical-footer-add-report', e.currentTarget);
  }
}

export default ReportsMenu;
